import { Flex, Group, Paper, Stack, Text } from '@mantine/core';
import { useState } from 'react';

import { CriteriaProjectFreeActivityChangeForm } from '@/module/Laboratory/criteria/components/CriteriaProjectFreeActivityChangeForm';
import { VisibilityActivity } from '@/module/ResearchCenter';

import { CriteriaItemEditButton } from './CriteriaItemEditButton';

interface CriteriaFreeActivityCardProps {
  index?: number;
  freeActivity: VisibilityActivity;
  onChange: (freeActivity: VisibilityActivity) => void;
  isPending: boolean;
  completed: boolean;
}

export function CriteriaFreeActivityCard({ freeActivity, index, onChange, isPending, completed }: CriteriaFreeActivityCardProps) {
  const [isEditable, setIsEditable] = useState(false);

  if (isEditable) {
    return (
      <CriteriaProjectFreeActivityChangeForm
        defaultValues={freeActivity}
        onChange={onChange}
        isSubmitting={isPending}
        onCancel={() => setIsEditable(false)}
      />
    );
  }
  return (
    <Paper
      p="sm"
      px="10px"
      bg="#FBFBFB"
      mr="6px"
      flex={1}
    >
      <Flex>
        {
          !completed && 
            <CriteriaItemEditButton
              index={index}
              onEdit={() => setIsEditable(true)}
        />
        }
        
        <Stack gap="4px">
          <Text>{freeActivity.title}</Text>
          <Group gap="5px">
            <Text
              size="sm"
              c="dimmed"
            >
              {freeActivity.organizer},
            </Text>
            <Text
              size="sm"
              c="dimmed"
              fs="italic"
            >
              {freeActivity.period}
            </Text>
          </Group>
        </Stack>
      </Flex>
    </Paper>
  );
}
